export interface ClusterLabel {
  title: string;
  [key: string]: unknown;
}

// The style fields labelUtils reads: per-cluster labels and lexicon overrides.
export interface LabelStyle {
  labels?: Record<string, { tap?: ClusterLabel; click?: ClusterLabel } | null>;
  lexicon?: Record<string, string | undefined>;
  [key: string]: unknown;
}

export function getClusterTapLabel(
  name: string,
  style: LabelStyle | null | undefined,
  lexiconField?: string,
): ClusterLabel {
  lexiconField = lexiconField || "hintTap";

  const labels = style ? style.labels : null;
  const lexicon = style ? style.lexicon : null;

  if (labels && name in labels) {
    const ret = labels[name];
    if (ret && ret.tap) {
      return ret.tap;
    }
  }

  const title = lexicon ? lexicon[lexiconField] : undefined;
  if (title) {
    return {
      title: title,
    };
  }

  return {
    title: "TAP ON IMAGE TO SHOP PRODUCT",
  };
}

export function getClusterClickLabel(
  name: string,
  style: LabelStyle | null | undefined,
  lexiconField?: string,
): ClusterLabel {
  lexiconField = lexiconField || "cta";

  const labels = style ? style.labels : null;
  const lexicon = style ? style.lexicon : null;

  if (labels && name in labels) {
    const ret = labels[name];
    if (ret && ret.click) {
      return ret.click;
    }
  }

  const title = lexicon ? lexicon[lexiconField] : undefined;
  if (title) {
    return {
      title: title,
    };
  }

  return {
    title: "SHOP THIS ITEM",
  };
}

export function getClusterLabel(
  name: string,
  style: LabelStyle | null | undefined,
  lexiconField?: string,
): { tap: ClusterLabel; click: ClusterLabel } {
  return {
    tap: getClusterTapLabel(name, style, lexiconField),
    click: getClusterClickLabel(name, style, lexiconField),
  };
}
